var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/itemUnselected.29d3e225.png","uri@2x": __webpack_public_path__ + "static/media/itemUnselected.fde68451.png","uri@3x": __webpack_public_path__ + "static/media/itemUnselected.391b4bcf.png",
    width: 24,
    height: 24
});